// Export configured PouchDB instance
export { default } from '../impl/couch/pouchdb-setup.js';